<template>
  <v-main>
    <v-container fluid>
      <v-row justify="center" class="mt-10">
        <v-col cols="12" md="8" class="text-center">
          <h1 class="display-1 font-weight-bold mb-3 primary--text">
            {{ $t('home.welcomeTitle') }}
          </h1>
          <p class="subtitle-1 grey--text text--darken-2">
            {{ $t('home.welcomeSubtitle') }}
          </p>
        </v-col>
      </v-row>

      <v-row justify="center" class="mt-5">
        <v-col
          v-for="mod in modules"
          :key="mod.key"
          cols="12"
          sm="6"
          md="4"
          lg="3"
          xl="2"
        >
          <v-card elevation="2" class="fill-height rounded-lg">
            <v-card-title class="text-body-1 font-weight-bold pb-2">
              <v-img
                v-if="mod.img"
                :src="$t(`menu.icons.${mod.img}`)"
                max-width="24"
                height="24"
                contain
                class="mr-2 flex-grow-0"
              ></v-img>
              <v-tooltip v-else-if="mod.deprecated" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="secondary"
                    class="mr-2 blink-animation"
                    v-bind="attrs"
                    v-on="on"
                    >mdi-alert-circle-outline</v-icon
                  >
                </template>
                <span>{{ $t('menu.deprecatedTooltip') }}</span>
              </v-tooltip>
              <v-icon v-else color="primary" class="mr-2">{{
                mod.icon
              }}</v-icon>
              {{ $t(`home.cards.${mod.key}.title`) }}
            </v-card-title>
            <v-card-text class="text-body-2 pb-0">
              {{ $t(`home.cards.${mod.key}.text`) }}
            </v-card-text>
            <v-card-actions>
              <v-btn
                text
                small
                :color="mod.deprecated ? 'secondary' : 'primary'"
                :to="{ name: mod.route }"
              >
                {{
                  mod.deprecated
                    ? $t('home.viewApis')
                    : $t('home.viewDocumentation')
                }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import { projectAuth } from '@/firebase/config'
import { showDeveloperAPI } from '@/helpers/sentinel'
import { mapGetters } from 'vuex'

export default {
  name: 'HomePage',

  components: {},

  data() {
    return {
      showDeveloperAPI: showDeveloperAPI,
    }
  },

  methods: {
    async logout() {
      projectAuth.signOut().then(() => {
        this.$router.push('/logout')
      })
    },
  },
  computed: {
    ...mapGetters([
      'getUpdateYourPackageStatus',
      'getUpdateYourPackageType',
      'getExplanationNPS_Status',
      'getExplanationNPSType',
    ]),
    modules() {
      const modules = [
        { key: 'engagement', img: 'engagement', route: 'engagement-service' },
        {
          key: 'performance',
          img: 'performance',
          route: 'performance-service',
        },
        { key: 'growth', img: 'growth', route: 'growth-service' },
        {
          key: 'customSurveys',
          img: 'custom_survey',
          route: 'custom-surveys-service',
        },
        {
          key: 'documentation',
          img: 'management',
          route: 'management-service',
        },
        { key: 'api', deprecated: true, route: 'apiData' },
        { key: 'apiImport', deprecated: true, route: 'apiDataImport' },
        {
          key: 'scim',
          icon: 'mdi-account-cog-outline',
          route: 'scim',
          gated: true,
        },
        { key: 'scimIdp', icon: 'mdi-account-sync-outline', route: 'scim-idp' },
        {
          key: 'mcpService',
          icon: 'mdi-robot-outline',
          route: 'mcp-service',
          gated: true,
        },
        { key: 'lms', icon: 'mdi-school-outline', route: 'lms', gated: true },
        {
          key: 'googleChatEvents',
          icon: 'mdi-chat-outline',
          route: 'google-chat-events',
          gated: true,
        },
        {
          key: 'notification',
          icon: 'mdi-bell-outline',
          route: 'notification',
          gated: true,
        },
        {
          key: 'rewards',
          icon: 'mdi-gift-outline',
          route: 'rewards',
          gated: true,
        },
        {
          key: 'trustline',
          icon: 'mdi-handshake-outline',
          route: 'trustline',
          gated: true,
        },
      ]
      return modules.filter((mod) => !mod.gated || this.showDeveloperAPI)
    },
  },
}
</script>

<style lang="scss" scoped>
.blink-animation {
  animation: blink 1.5s infinite;
}

@keyframes blink {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
}
</style>
